<template>
  <div class="documentsWrapper">
    <span class="sectionTitle">Factures</span>
    <div class="documentsGridWrapper">
      <div class="cardLayoutWrapper cardLayoutWrapper--header">
        <div class="elem elem--span-1"></div>
        <div class="elem elem--span-5">
          <span>Référence Facture</span>
        </div>
        <div class="elem elem--span-5">
          <span>Montant TTC</span>
        </div>
        <div class="elem elem--span-10">
          <span>Dossier(s)</span>
        </div>
      </div>
      <div
        class="gridElemWrapper"
        v-for="(elem, index) in factures"
        :key="index"
      >
        <div class="cardLayoutWrapper">
          <div class="elem elem--span-1"></div>
          <div
            class="elem elem--span-5 elem--bold elem--nowrap elem--clickable"
            @click="routingService.navigateToFactureWithKey(elem.code)"
          >
            <span>{{ elem.reference }}</span>
          </div>
          <div class="elem elem--span-5">
            <span>{{ formatNumber(elem.montantTTC, { decimal: 2, separateur: true }) }} €</span>
          </div>
          <div class="elem elem--span-10 elem--nowrap">
            <span>{{ elem.dossiers[0]?.code }}</span>
            <span v-if="elem.dossiers.length > 1">+ {{ elem.dossiers.length - 1 }}</span>
          </div>
          <div class="elem elem--span-7"></div>
          <div class="elem elem--span-3">
            <BasicButton
              v-if="elem.dossiers.length > 1"
              label="Détails"
              iconRight
              size="small"
              :iconName="drawerId === index ? 'arrow-up' : 'arrow-down'"
              @click="toggleDrawer(index)"
            />
          </div>
          <div class="elem elem--span-5">
            <BasicButton
              label="Consulter la facture"
              size="small"
              iconName="eye"
              type="secondary"
              variant="outlined"
              @click="routingService.navigateToFactureWithKey(elem.code)"
            />
          </div>
        </div>
        <div v-if="drawerId === index">
          <div class="gridElemWrapper">
            <div class="cardLayoutWrapper cardLayoutWrapper--drawer cardLayoutWrapper--factureList">
              <BasicText weight="bold">{{ 'Dossiers : ' }}</BasicText>
              <div class="drawer">
                <span
                  v-for="(dossier, index) in dossiersList(elem.dossiers)"
                  :key="index"
                  class="elem"
                >
                  {{ dossier }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="documentsMobileWrapper">
      <div
        class="documentsMobileElemWrapper"
        v-for="(elem, index) in factures"
        :key="index"
      >
        <div class="headerWrapper">
          <div class="leftContent">
            <BasicCard
              class="cardMobile"
              :title="'Facture n° ' + `${elem.reference}`"
              :subtitles="[
                {
                  text: 'Montant TTC : ' + formatNumber(elem.montantTTC, { decimal: 2, separateur: true }) + ' €',
                  icon: 'wallet',
                },
                { text: 'Dossier(s) : ' + elem.dossiers.length, icon: 'folder' },
              ]"
            />
          </div>
          <div class="rightContent">
            <BasicButton
              label="Consulter la facture"
              size="small"
              iconName="eye"
              type="secondary"
              variant="outlined"
              @click="routingService.navigateToFactureWithKey(elem.code)"
            />
            <BasicButton
              label="Détails"
              iconRight
              size="small"
              :iconName="drawerId === index ? 'arrow-up' : 'arrow-down'"
              @click="toggleDrawer(index)"
            />
          </div>
        </div>
        <div
          class="bottomWrapper"
          v-if="drawerId === index"
        >
          <div class="bottomElemWrapper">
            <BasicText weight="bold">{{ 'Dossiers : ' }}</BasicText>
            <div class="bottomElem">
              <span
                v-for="(dossier, index) in dossiersList(elem.dossiers)"
                :key="index"
                class="elem"
              >
                {{ dossier }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import type { DossierDTO } from '@/features/api/extranet/dto/Virement/DossierDTO'
  import type { FactureDTO } from '@/features/api/extranet/dto/Virement/FactureDTO'
  import { useVirementRoutingService } from '../useVirementRoutingService'
  import { formatNumber } from '@/features/shared/tools'
  const routingService = useVirementRoutingService()

  defineProps<{
    factures: FactureDTO[]
  }>()

  const dossiersList = (dossiers: DossierDTO[]) => {
    if (!dossiers || !dossiers.length) return []

    return dossiers.map((dossier) => {
      return dossier.code ?? ''
    })
  }

  const drawerId = ref()
  const toggleDrawer = (id: number) => {
    if (drawerId.value === id) {
      drawerId.value = null
    } else {
      drawerId.value = id
    }
  }
</script>

<style scoped lang="less">
  @import '../../index.less';
</style>
